<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.ExpensesRecord}}</p>
    </div>
    <div class="screen-box">
      <div class="time-scree">
        <p class="time" @click="dateModel = true">
          {{words.Time}}：
          <span>{{page.start}}-{{page.end}}</span>&nbsp;
          <img :src="TimeIcon" class="icon" />
        </p>
      </div>
      <div class="search-box">
        <img
          :src="exportStatus ? exportIconClick : exportIcon"
          alt
          class="export"
          @click="exportData(0)"
        />

        <div class="input-box">
          <input type="text" class="input" v-model="page.key" />
          <img :src="btnSearchStatus ? btnSearchClick : btnSearch" class="btn" @click="dateOK" />
        </div>
        <!-- <div class="export"></div> -->
      </div>
    </div>
    <div class="table-box">
      <Table size="large" :loading="loading" :columns="columns" stripe :data="data" :height="700"></Table>
    </div>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" />
    </div>

    <Modal v-model="dateModel" title="请选择开始和结束时间" @on-ok="dateOK" @on-cancel="dateCancel">
      <div style="padding:20px;">
        <DatePicker
          type="month"
          placeholder="请选择开始时间"
          style="width: 200px"
          @on-change="startDateOk"
        ></DatePicker>
        <DatePicker
          type="month"
          placeholder="请选择结束时间"
          style="width: 200px;margin-left:20px;"
          @on-change="endDateOk"
        ></DatePicker>
      </div>
    </Modal>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import excel from "../../utils/excel";
export default {
  components: {},
  data() {
    return {
      loading: false,
      columns: [],
      data: [],
      btnSearch: require("../../assets/search.png"),
      btnSearchClick: require("../../assets/search_click.png"),
      btnSearchStatus: false,
      TimeIcon: require("../../assets/arrow_bottom.png"),
      exportIcon: require("../../assets/export.png"),
      exportIconClick: require("../../assets/export_click.png"),
      exportStatus: false,

      dateModel: false,
      page: {
        p: 0,
        l: 10,
        key: "",
        start: "",
        end: ""
      },
      total: 0
    };
  },
  mounted() {
    this.columns = [
      {
        title: this.words.JobDate,
        key: "result_time",
        width: 200,
        className: "table-header-col",
        // fixed:"left",
        render: (h, data) => {
          return h("span", this.$moment(new Date(data.row.result_time)));
        }
      },
      {
        title: this.words.Type,
        key: "job_type",
        className: "table-header-col",
        width: 120,
        // fixed:"left",
        render: (h, data) => {
          return h(
            "span",
            data.row.job_type === 1
              ? this.words.ExpensesPrint
              : data.row.job_type === 2
              ? this.words.ExpensesCopy
              : data.row.job_type === 3
              ? this.words.ExpensesScan
              : data.row.job_type === 4
              ? "传真消费"
              : data.row.job_type === 5
              ? "相片冲印"
              : data.row.job_type === 6
              ? "身份证复印"
              : ""
          );
        }
      },
      {
        title: this.words.Name,
        key: "file_real_name",
        className: "table-header-col",
        width: 300,
        // fixed:"left",
        render: (h, data) => {
          return h(
            "span",
            data.row.file_real_name ? data.row.file_real_name : "-"
          );
        }
      },
      {
        title: this.words.Size,
        key: "sizes",
        className: "table-header-col",
        width: 80
      },
      {
        title: this.words.OriginalFileNumber,
        key: "pages",
        className: "table-header-col",
        width: 150
      },
      {
        title: this.words.PlanTotalPages,
        key: "plan_total_pages",
        className: "table-header-col",
        width: 150
      },
      {
        title: this.words.ActualPaperOutput,
        key: "total_pages",
        className: "table-header-col",
        width: 120
      },
      {
        title: this.words.Colour,
        key: "color",
        className: "table-header-col",
        width: 100,
        render: (h, data) => {
          return h("span", data.row.color ? this.words.Colour : this.words.BW);
        }
      },
      {
        title: this.words.OrderNumber,
        key: "order_no",
        className: "table-header-col",
        width: 200
      },
      {
        title: this.words.Site,
        key: "site_name",
        className: "table-header-col",
        width: 220
      },
      {
        title: this.words.Device,
        key: "sn",
        className: "table-header-col",
        width: 220
      },
      {
        title: this.words.OrderAmount,
        key: "money",
        className: "table-header-col",
        width: 100
      },
      {
        title: this.words.Refund,
        key: "return_money",
        className: "table-header-col",
        width: 100
      },
      {
        title: this.words.Deduction,
        key: "coupon_money",
        className: "table-header-col",
        width: 120
      },
      {
        title: this.words.Expenses_details_EventOffer,
        key: "activity_money",
        className: "table-header-col",
        width: 120
      },
      {
        title: this.words.PayMode,
        key: "money_type",
        className: "table-header-col",
        width: 120,
        render: (h, data) => {
          return h(
            "span",
            data.row.money_type === -1
              ? "未支付"
              : data.row.money_type === 0
              ? this.words.payModeWallet
              : data.row.money_type === 1
              ? this.words.payModeWechat
              : data.row.money_type === 2
              ? this.words.payModeAliPay
              : data.row.money_type === 3
              ? this.words.payModeFree
              : data.row.money_type === 4 || data.row.money_type === 5
              ? this.words.payModeCorporateWallet
              : ""
          );
        }
      },
      {
        title: this.words.ActualPayment,
        key: "result_money",
        className: "table-header-col",
        width: 150,
        render: (h, data) => {
          return h(
            "span",
            (data.row.result_money - data.row.return_money).toFixed(2) || 0.0
          );
        }
      }
    ];

    this.page.start = this.$momentDate(new Date().setDate(-180), "YYYY.MM");
    this.page.end = this.$momentDate(new Date().setDate(), "YYYY.MM");
    this.init();
  },
  methods: {
    ...mapActions(["GetUserJoibList"]),
    init() {
      this.getData();
    },
    startDateOk(e) {
      this.page.start = this.$momentDate(new Date(e), "YYYY.MM");
    },
    endDateOk(e) {
      this.page.end = this.$momentDate(new Date(e), "YYYY.MM");
    },
    dateOK() {
      this.page.p = 0;
      this.getData();
    },
    dateCancel() {},
    pageChange(e) {
      this.page.p = e - 1;
      this.getData();
    },
    sizeChange(e) {
      this.page.p = p - 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.GetUserJoibList(this.page).then(res => {
        console.log(res);
        // res.data.map(item=>{
        // item.total_pages = item.total_pages * item.copies;
        // })
        this.data = res.data;
        this.total = res.total;
        this.loading = false;
      });
    },
    exportData(is_all) {
      let title = [],
        key = [];
      this.columns.map(item => {
        title.push(item.title);
        key.push(item.key);
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "消费记录" + new Date().getTime()
      };
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        this.getCompany(page).then(res => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map(item => {
        item.result_time = this.$moment(new Date(item.result_time));
        let job_type = {
          "1": "打印消费",
          "2": "复印消费",
          "3": "扫描消费",
          "4": "传真消费",
          "5": "打相片冲印印消费",
          "6": "身份证复印"
        };

        item.job_type = job_type[item.job_type];

        item.color = item.color ? this.words.Colour : this.words.BW;

        let type = {
          "1": "钱包",
          "2": "微信",
          "3": "支付宝",
          "4": "未免费支付",
          "5": "企业钱包"
        };
        console.log(type[item.money_type + 1]);
        item.money_type = type[item.money_type + 1];
      });
      return result;
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>